{
  "title": "Clients",
  "search": "Recherche",
  "table": {
    "id": "Pièce d'identité",
    "name": "Nom",
    "email": "Courriel",
    "suitabilityScore": "Score d'adéquation",
    "complianceIssue": "État de conformité",
    "createdAt": "Créé à",
    "completedAt": "Terminé à",
    "organization": "Organisation",
    "province": "Province",
    "dateOfBirth": "Date de naissance",
    "notCompleted": "Non finalisé",
    "custodianAccountNumbers": "Compte #",
    "goals": "Objectifs",
    "portfolioRiskLevels": "Niveaux de risque",
    "marketValue": "Total des actifs"
  }
}
